import React from 'react';
import {
  LibraryItemSortBy,
  Orientation,
} from '@wix/ambassador-file-sharing-v1-settings/types';
import { SortDown, SortUp } from '@wix/wix-ui-icons-common/on-stage';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from '../TableHeader.st.css';
import biService from '../../../../../../BiEvents/BiService';
import { BI_FILE_SHARE_WIDGET_SORT_BY } from '../../../../../../BiEvents/Constants/BiConstants';

const FavoritesComponent = ({
  name,
  sortBy,
  orientation,
  handleTitleColumnOnClick,
  disabledTableHeader,
  isMembersArea,
}: any) => {
  const className = disabledTableHeader ? classes.disabledHeader : '';
  const suffixIcon: any =
    sortBy === LibraryItemSortBy.TIMES_FAVORITED &&
    (orientation === Orientation.DESC ? (
      <SortDown className={className} aria-hidden="true" />
    ) : (
      <SortUp className={className} aria-hidden="true" />
    ));
  return (
    <div
      style={{
        display: 'flex',
        fontSize: '14px',
        alignItems: 'center',
      }}
    >
      <TextButton
        className={st(classes.tableHeaderColumn, { isMembersArea })}
        contentClassName={classes.contentEllipsis}
        suffixIcon={suffixIcon}
        priority={TextButtonPriority.secondary}
        onClick={() => {
          if (!disabledTableHeader) {
            handleTitleColumnOnClick({
              sortBy,
              selectedId: LibraryItemSortBy.TIMES_FAVORITED,
            });
            biService(
              { button_description: 'stars', is_first: false },
              BI_FILE_SHARE_WIDGET_SORT_BY,
            );
          }
        }}
        title={name}
      >
        {name}
      </TextButton>
    </div>
  );
};
export default FavoritesComponent;
